// Imagen por defecto para compartir en redes (logo de La Estrofa sobre fondo azul).
// Las páginas de detalle (noticias, canciones) sobreescriben con su portada.
export const DEFAULT_OG_IMAGE =
  process.env.REACT_APP_DEFAULT_OG_IMAGE ||
  "https://customer-assets.emergentagent.com/job_790c710a-9552-4ae0-9987-8cb46a1fd898/artifacts/8f43c3r0_logo-1024x1024%20%281%29.jpg";

// Dominio canónico de producción (sin barra final). Configurable por entorno.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://laestrofa.es").replace(/\/$/, "");
// Construye una URL canónica absoluta a partir de una ruta ("/noticias/...").
export const canonicalUrl = (path = "/") => `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

// Enlace para compartir en redes: pasa por el backend (/api/share) que sirve las etiquetas
// Open Graph con la PORTADA real, para que WhatsApp/Facebook/X/Telegram muestren la imagen.
const SHARE_BASE = (process.env.REACT_APP_BACKEND_URL || SITE_URL).replace(/\/$/, "");
export const shareUrl = (kind, slug) => `${SHARE_BASE}/api/share/${kind}/${slug}`;
